/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {

  sysManagement: { SC: "系统管理", TC: "系統管理", EN: "System" }
  , update: { SC: "修改", TC: "修改", EN: "Edit" }
  , delete: { SC: "删除", TC: "刪除", EN: "Delete" }
  , audit: { SC: "日志", TC: "日誌", EN: "Log" }
  , view: { SC: "詳情", TC: "詳情", EN: "View" }
  , selectiveData: { SC: "请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
  , deleteData: { SC: "数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
  , deleteSuccess: { SC: "删除成功", TC: "刪除成功", EN: "Deleted successfully." }
  , beQuerying: { SC: "查询中...", TC: "査詢中...", EN: "Searching..." }
  , noneDate: { SC: "找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
  , saveSuccess: { SC: "保存成功", TC: "保存成功", EN: "Saved successfully." }
  , controls: { SC: "操作", TC: "操作", EN: "Operation" }
  , list: { SC: "列表", TC: "列表", EN: "List" }
  , search: { SC: "查询", TC: "査詢", EN: "Search" }
  , reset: { SC: "重置", TC: "重置", EN: "Reset" }
  , add: { SC: "新增", TC: "新增", EN: "Add" }
  , save: { SC: "保存", TC: "保存", EN: "Save" }
  , cancel: { SC: "取消", TC: "取消", EN: "Cancel" }
  , clear: { SC: "清空", TC: "清空", EN: "Clear" }
  , dataBeSaving: { SC: "数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }

  , startDateNoIsNull: { SC: "开始日期不能为空", TC: "開始日期不能為空" , EN: "State Date is required." }
  , startDateMax: { SC: "开始日期不能晚于结束日期", TC: "開始日期不能晚於結束日期" , EN: "The start date cannot be later than the end date." }
  , endDateNoIsNull: { SC: "结束日期不能为空", TC: "結束日期不能為空" , EN: "End Date" }
  , endDateMin: { SC: "结束日期不能早于开始日期", TC: "結束日期不能早於開始日期" , EN: "The end date cannot be earlier than the start date." }
  , userCode: { SC: "用户", TC: "用戶" , EN: "User Code" }
  , userName: { SC: "姓名", TC: "姓名" , EN: "Name" }
  , funcName: { SC: "模块名称", TC: "模塊名稱" , EN: "Function Name" }
  , userLogin: { SC: "用户登录", TC: "用戶登錄" , EN: "User Login" }
  , userLoginOut: { SC: "用戶登出", TC: "用戶登出" , EN: "User Log Out" }
  , search2: { SC: "查找中...", TC: "查找中…", EN: "Searching..." }
  , operationType: { SC: "操作类型", TC: "操作類型" , EN: "Operation Type" }
  , operationContent: { SC: "操作內容", TC: "操作內容" , EN: "Operation Content" }
  , operationTime: { SC: "操作时间", TC: "操作時間" , EN: "Operation Time" }
  , loginIpAddress: { SC: "登录IP地址", TC: "登錄IP地址" , EN: "Login IP Address" }
  , zhi: { SC: "至", TC: "至" , EN: "to" }
  , startTime: { SC: "开始时间", TC: "開始時間" , EN: "Start Time" }
  , endTime: { SC: "结束时间", TC: "結束時間" , EN: "End Time" }
  , sysManage: { SC: "系统管理", TC: "系統管理" , EN: "System" }

  , confirmDelete: { SC: "您确认要删除吗？", TC: "您確認要刪除嗎？1" , EN: "Confirm delete?" }
  , confirm: { SC: "确认要", TC: "確認要" , EN: "Confirm " }
  , enable: { SC: "启用", TC: "啓用" , EN: "enable " }
  , stop: { SC: "停用", TC: "停用" , EN: "stop " }
  , task: { SC: "任务吗?", TC: "任務嗎？" , EN: " task?" }
  , immediateExecution: { SC: "确认要立即执行一次", TC: "確認要立即執行一次" , EN: "Confirm immediately execute once" }
  , executeOnce: { SC: "执行一次", TC: "執行一次" , EN: "Execute once" }
  , taskExecution: { SC: "任务执行中...", TC: "任務執行中..." , EN: "Task execution..." }
  , executedSuccess: { SC: "执行成功", TC: "執行成功" , EN: "Executed successfully." }

  , jobName: { SC: "任务名称", TC: "任務名稱" , EN: "Job Name" }
  , jobGroup: { SC: "任务组名", TC: "任務組名" , EN: "Job Group" }
  , invokeTarget: { SC: "调用目标字符串", TC: "調用目標字符串" , EN: "Invoke Target" }
  , cronExpression: { SC: "cron执行表达式", TC: "cron執行表達式" , EN: "Cron Expression" }
  , cronExpressionNoIsNull: { SC: "cron执行表达式", TC: "cron執行表達式" , EN: "Cron Expression" }
  , status: { SC: "状态", TC: "狀態" , EN: "Status" }
  , timeTask: { SC: "定时任务", TC: "定時任務" , EN: "Time Task" }
  , jobNameNoIsNull: { SC: "任务名称不能为空", TC: "任務名稱不能爲空" , EN: "Job Name is required." }
  , invokeMethod: { SC: "调用方法", TC: "調用方法" , EN: "Invoke Target" }
  , invokeTargetNoIsNull: { SC: "调用方法不能为空", TC: "調用方法不能爲空" , EN: "Invoke Target is required." }
  , misfirePolicy: { SC: "错误策略", TC: "錯誤策略" , EN: "Misfire Policy" }
  , concurrent: { SC: "是否并发", TC: "是否并發" , EN: "Concurrent" }

  , jobMessage: { SC: "日志信息", TC: "日志信息" , EN: "Job Message" }
  , executeStatus: { SC: "执行状态", TC: "執行狀態" , EN: "Execute Status" }
  , createdDate: { SC: "执行时间", TC: "執行時間" , EN: "Execute Date" }
  , schedulingLogDetail: { SC: "调度日志详情", TC: "調度日志詳情" , EN: "Scheduling Log Detail" }
  , close: { SC: "关闭", TC: "關閉" , EN: "Close" }
  , exception: { SC: "异常", TC: "異常" , EN: "Exception" }
  , empty: { SC: "是否确认清空所有调度日志？", TC: "是否確認清空所有調度日志？" , EN: "Do you want to clear all scheduling logs?" }
}